<!--
 * @Description: 供应商销售排行榜（带饼图联动）
 * @Author: xiawenlong
 * @Date: 2024-11-25 14:22:25
 * @LastEditors: xiawenlong
-->
<template>
  <div class="supplier-sales-rank">
    <div class="header">
      <div class="title">
        <img src="@/img/datav-tc/title_icon.png" alt="" />
        <span>供应商销售排行榜</span>
      </div>
      <div class="tab">
        <div :class="['tab-item', { active: timeRange == 'all' }]" @click="timeRangeChange('all')">
          全部
        </div>
        <div
          :class="['tab-item', { active: timeRange == 'year' }]"
          @click="timeRangeChange('year')"
        >
          今年
        </div>
        <div
          :class="['tab-item', { active: timeRange == 'halfYear' }]"
          @click="timeRangeChange('halfYear')"
        >
          过去半年
        </div>
        <div
          :class="['tab-item', { active: timeRange == 'month' }]"
          @click="timeRangeChange('month')"
        >
          本月
        </div>
      </div>
    </div>
    <div class="content">
      <div class="rank-section">
        <div class="rank-header">
          <span class="rank-title">排名</span>
          <span class="name-title">供应商名称</span>
          <span class="amount-title">销售金额</span>
        </div>
        <div class="rank-list-wrapper">
          <div class="rank-list" :style="scrollStyle">
            <div
              v-for="(item, index) in displayData"
              :key="index"
              class="rank-item"
              :class="{ active: isActive(index) }"
              @click="selectSupplier(index)"
            >
              <div
                class="rank-num"
                :class="{
                  'top-1': index === 0,
                  'top-2': index === 1,
                  'top-3': index === 2,
                }"
              >
                <span>{{ index + 1 }}</span>
              </div>
              <div class="supplier-name">{{ item.name }}</div>
              <div class="amount">{{ item.value }}万元</div>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-section">
        <div id="SupplierPieChart" style="width: 100%; height: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getSupplierSalesRank } from '@/api/dashboard-tc'
let myChart

export default {
  data() {
    return {
      timeRange: 'all',
      activeIndex: 0,
      scrollOffset: 0,
      itemHeight: 50,
      visibleCount: 5, // 默认可视区域可显示的item数量，会在mounted时重新计算
      data: {
        all: [],
        year: [],
        halfYear: [],
        month: [],
      },
      pieData: [
        { value: 30, name: '蔬菜水果' },
        { value: 28, name: '肉蛋家禽' },
        { value: 22, name: '米面粮油' },
        { value: 15, name: '鱼虾水产' },
        { value: 5, name: '其他' },
      ],
      dataTimer: null,
    }
  },
  computed: {
    currentData() {
      return this.data[this.timeRange]
    },
    dataLength() {
      return this.currentData.length
    },
    // 只使用一份数据，不复制
    displayData() {
      return this.currentData
    },
    scrollStyle() {
      return {
        transform: `translateY(-${this.scrollOffset}px)`,
        transition: 'transform 0.5s linear',
      }
    },
  },
  watch: {
    timeRange() {
      this.fetchData()
      this.activeIndex = 0
      this.scrollOffset = 0
    },
  },
  mounted() {
    myChart = echarts.init(document.getElementById('SupplierPieChart'))
    myChart.resize()
    window.addEventListener('resize', () => {
      myChart.resize()
    })
    // 计算可视区域能显示多少个item
    this.calcVisibleCount()
    this.fetchData()
    this.startAutoScroll()
    this.dataTimer = setInterval(() => {
      this.fetchData()
    }, process.env.VUE_APP_LTIME_TC)
  },
  beforeDestroy() {
    clearInterval(this.scrollTimer)
    clearInterval(this.selectTimer)
    clearInterval(this.dataTimer)
  },
  methods: {
    async fetchData() {
      try {
        const res = await getSupplierSalesRank({ timeRange: this.timeRange })
        if (res.code === 0) {
          this.data[this.timeRange] = res.data.list
          if (res.data.list.length > 0) {
            this.pieData = res.data.list[0].pieData
          }
          this.initChart()
        }
      } catch (error) {
        console.error('获取供应商销售排行失败:', error)
      }
    },
    initChart() {
      // 霓虹色彩方案
      const neonColors = [
        { start: '#FF006E', end: '#8338EC', glow: '#FF006E' },
        { start: '#3A86FF', end: '#00F5FF', glow: '#3A86FF' },
        { start: '#FFBE0B', end: '#FB5607', glow: '#FFBE0B' },
        { start: '#06FFA5', end: '#00C9A7', glow: '#06FFA5' },
        { start: '#FF4081', end: '#F50057', glow: '#FF4081' },
      ]

      const formattedData = this.pieData.map((item, index) => {
        const colorSet = neonColors[index % neonColors.length]
        return {
          ...item,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 1,
              y2: 1,
              colorStops: [
                { offset: 0, color: colorSet.start },
                { offset: 1, color: colorSet.end },
              ],
            },
            shadowBlur: 20,
            shadowColor: colorSet.glow,
            borderRadius: 8,
          },
        }
      })

      const option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(5, 13, 76, 0.9)',
          borderColor: '#00c0fe',
          borderWidth: 1,
          textStyle: {
            fontSize: 14,
            color: '#fff',
          },
          formatter: params => {
            return `
              <div style="padding: 8px;">
                <div style="font-size: 16px; font-weight: bold; margin-bottom: 4px; color: #00c0fe;">${params.name}</div>
                <div style="font-size: 14px;">金额: <span style="color: #66ffff; font-weight: bold;">${params.value}万元</span></div>
                <div style="font-size: 14px;">占比: <span style="color: #ffaa00; font-weight: bold;">${params.percent}%</span></div>
              </div>
            `
          },
        },
        series: [
          {
            name: '商品类型',
            type: 'pie',
            radius: ['0%', '65%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: 'rgba(5, 13, 76, 0.5)',
              borderWidth: 2,
              borderRadius: 6,
            },
            label: {
              show: true,
              fontSize: 13,
              color: '#fff',
              formatter: params => {
                return `{name|${params.name}}\n{value|${params.value}万}`
              },
              rich: {
                name: {
                  fontSize: 12,
                  color: '#899dbf',
                  padding: [0, 0, 4, 0],
                },
                value: {
                  fontSize: 14,
                  color: '#66ffff',
                  fontWeight: 'bold',
                },
              },
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 20,
              lineStyle: {
                color: 'rgba(0, 192, 254, 0.3)',
              },
            },
            emphasis: {
              scale: true,
              scaleSize: 10,
              itemStyle: {
                shadowBlur: 30,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 192, 254, 0.5)',
              },
              label: {
                fontSize: 15,
                fontWeight: 'bold',
              },
            },
            data: formattedData,
            animationType: 'scale',
            animationEasing: 'elasticOut',
            animationDelay: () => {
              return Math.random() * 200
            },
          },
          {
            name: '装饰环',
            type: 'pie',
            radius: ['25%', '26%'],
            center: ['50%', '50%'],
            itemStyle: {
              color: 'rgba(0, 192, 254, 0.1)',
            },
            label: { show: false },
            data: [{ value: 1 }],
            silent: true,
            z: 0,
          },
          {
            name: '外发光环',
            type: 'pie',
            radius: ['68%', '70%'],
            center: ['50%', '50%'],
            itemStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  { offset: 0, color: 'rgba(0, 192, 254, 0)' },
                  { offset: 0.5, color: 'rgba(0, 192, 254, 0.05)' },
                  { offset: 1, color: 'rgba(0, 192, 254, 0.2)' },
                ],
              },
            },
            label: { show: false },
            data: [{ value: 1 }],
            silent: true,
            z: 0,
          },
        ],
      }
      myChart.setOption(option)
    },
    timeRangeChange(range) {
      this.timeRange = range
    },
    selectSupplier(index) {
      this.activeIndex = index
      this.updatePieData()
    },
    // 计算可视区域能显示多少个item
    calcVisibleCount() {
      this.$nextTick(() => {
        const wrapper = this.$el.querySelector('.rank-list-wrapper')
        if (wrapper) {
          this.visibleCount = Math.floor(wrapper.clientHeight / this.itemHeight)
        }
      })
    },
    isActive(index) {
      // 判断是否为当前选中项
      return index === this.activeIndex
    },
    updatePieData() {
      const currentSupplier = this.currentData[this.activeIndex]
      if (!currentSupplier || !currentSupplier.pieData) return

      const neonColors = [
        { start: '#FF006E', end: '#8338EC', glow: '#FF006E' },
        { start: '#3A86FF', end: '#00F5FF', glow: '#3A86FF' },
        { start: '#FFBE0B', end: '#FB5607', glow: '#FFBE0B' },
        { start: '#06FFA5', end: '#00C9A7', glow: '#06FFA5' },
        { start: '#FF4081', end: '#F50057', glow: '#FF4081' },
      ]

      const newData = currentSupplier.pieData.map((item, index) => {
        const colorSet = neonColors[index % neonColors.length]
        return {
          ...item,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 1,
              y2: 1,
              colorStops: [
                { offset: 0, color: colorSet.start },
                { offset: 1, color: colorSet.end },
              ],
            },
            shadowBlur: 20,
            shadowColor: colorSet.glow,
            borderRadius: 8,
          },
        }
      })

      myChart.setOption({
        series: [
          {
            data: newData,
          },
        ],
      })
    },
    startAutoScroll() {
      this.activeIndex = 0
      this.scrollOffset = 0
      this.updatePieData()

      // 滚动和选中状态切换（合并为一个定时器，确保同步）
      this.scrollTimer = setInterval(() => {
        if (this.dataLength === 0) return

        // 切换到下一个选中项
        this.activeIndex = (this.activeIndex + 1) % this.dataLength
        this.updatePieData()

        // 只有数据超出一屏时才需要滚动
        if (this.dataLength > this.visibleCount) {
          // 计算最大滚动偏移量（确保不会滚动到出现空白）
          const maxScrollOffset = (this.dataLength - this.visibleCount) * this.itemHeight

          // 如果选中项超出可视区域底部，且滚动后不会出现空白，则滚动
          if (this.activeIndex >= this.visibleCount) {
            const targetOffset = (this.activeIndex - this.visibleCount + 1) * this.itemHeight
            // 限制最大滚动偏移量，防止出现空白
            this.scrollOffset = Math.min(targetOffset, maxScrollOffset)
          } else {
            // 选中项在可视区域内，不滚动
            this.scrollOffset = 0
          }
        }
      }, 2000)
    },
  },
}
</script>

<style lang="scss" scoped>
.supplier-sales-rank {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 30px 30px;
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    flex-shrink: 0;

    .title {
      font-size: 22px;
      color: #ecf8ff;
      display: flex;
      align-items: center;
      font-weight: 600;
      letter-spacing: 1px;
      text-shadow: 0 0 20px rgba(0, 192, 254, 0.5);

      img {
        margin-right: 8px;
        filter: drop-shadow(0 0 8px rgba(0, 192, 254, 0.6));
      }
    }

    .tab {
      display: flex;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 20px;
      border: 1px solid rgba(0, 192, 254, 0.3);
      padding: 3px;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        inset: -2px;
        background: linear-gradient(90deg, #00c0fe, #126dff, #00c0fe);
        border-radius: 22px;
        z-index: -1;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      &:hover::before {
        opacity: 0.3;
      }

      .tab-item {
        padding: 0 16px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        transition: all 0.3s ease;
        border-radius: 13px;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(0, 192, 254, 0.2), rgba(18, 109, 255, 0.2));
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        &:hover {
          color: #66ffff;

          &::before {
            opacity: 1;
          }
        }

        &.active {
          background: linear-gradient(90deg, #00c0fe 0%, #126dff 100%);
          color: #fff;
          box-shadow: 0 0 15px rgba(0, 192, 254, 0.5), inset 0 0 10px rgba(255, 255, 255, 0.2);
          font-weight: 600;

          &::before {
            display: none;
          }
        }
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    overflow: hidden;

    .rank-section {
      width: 55%;
      display: flex;
      flex-direction: column;

      .rank-header {
        display: flex;
        align-items: center;
        padding: 8px 0;
        border-bottom: 1px solid rgba(0, 192, 254, 0.3);
        margin-bottom: 8px;
        flex-shrink: 0;

        .rank-title {
          width: 40px;
          font-size: 16px;
          color: #899dbf;
          text-align: center;
        }

        .name-title {
          flex: 1;
          font-size: 16px;
          color: #899dbf;
          padding-left: 10px;
        }

        .amount-title {
          width: 80px;
          font-size: 16px;
          color: #899dbf;
          text-align: right;
        }
      }

      .rank-list-wrapper {
        flex: 1;
        overflow: hidden;
        position: relative;

        .rank-list {
          position: absolute;
          width: 100%;
          left: 0;
          top: 0;

          .rank-item {
            display: flex;
            align-items: center;
            padding: 10px 12px;
            height: 44px;
            box-sizing: border-box;
            cursor: pointer;
            transition: all 0.3s ease;
            border-radius: 8px;
            margin-bottom: 6px;
            position: relative;
            overflow: hidden;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              height: 100%;
              width: 3px;
              background: linear-gradient(180deg, #00c0fe 0%, #126dff 100%);
              opacity: 0;
              transition: opacity 0.3s ease;
            }

            &::after {
              content: '';
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 0;
              height: 0;
              border-style: solid;
              border-width: 6px 0 6px 8px;
              border-color: transparent transparent transparent rgba(102, 255, 255, 0.6);
              opacity: 0;
              transition: all 0.3s ease;
            }

            &:hover {
              background: linear-gradient(
                90deg,
                rgba(0, 192, 254, 0.15) 0%,
                rgba(0, 192, 254, 0.05) 100%
              );
              transform: translateX(4px);

              &::before {
                opacity: 1;
              }

              .amount {
                color: #fff;
                text-shadow: 0 0 10px rgba(102, 255, 255, 0.8);
              }
            }

            &.active {
              background: linear-gradient(
                90deg,
                rgba(0, 192, 254, 0.25) 0%,
                rgba(18, 109, 255, 0.1) 100%
              );
              border: 1px solid rgba(0, 192, 254, 0.4);
              box-shadow: 0 0 20px rgba(0, 192, 254, 0.2), inset 0 0 20px rgba(0, 192, 254, 0.05);

              &::before {
                opacity: 1;
              }

              &::after {
                opacity: 1;
                right: 10px;
              }

              .amount {
                color: #fff;
                text-shadow: 0 0 15px rgba(102, 255, 255, 1);
              }

              .supplier-name {
                color: #fff;
              }
            }

            .rank-num {
              width: 28px;
              height: 28px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 8px;
              font-size: 13px;
              color: #ffffff;
              margin-right: 12px;
              background: rgba(0, 192, 254, 0.15);
              border: 1px solid rgba(0, 192, 254, 0.4);
              flex-shrink: 0;
              font-weight: 600;
              position: relative;
              overflow: hidden;

              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(
                  90deg,
                  transparent,
                  rgba(255, 255, 255, 0.2),
                  transparent
                );
                animation: shimmer 3s infinite;
              }

              @keyframes shimmer {
                0% {
                  left: -100%;
                }
                50%,
                100% {
                  left: 100%;
                }
              }

              &.top-1 {
                background: linear-gradient(135deg, #ff006e 0%, #8338ec 100%);
                border: none;
                font-weight: bold;
                box-shadow: 0 0 15px rgba(255, 0, 110, 0.5), inset 0 0 10px rgba(255, 255, 255, 0.2);
                border-radius: 50% 50% 50% 4px;
                transform: rotate(-45deg);
                span {
                  transform: rotate(45deg);
                }
              }

              &.top-2 {
                background: linear-gradient(135deg, #3a86ff 0%, #00f5ff 100%);
                border: none;
                font-weight: bold;
                box-shadow: 0 0 12px rgba(58, 134, 255, 0.4), inset 0 0 8px rgba(255, 255, 255, 0.2);
                border-radius: 50% 50% 4px 50%;
                transform: rotate(-45deg);
                span {
                  transform: rotate(45deg);
                }
              }

              &.top-3 {
                background: linear-gradient(135deg, #ffbe0b 0%, #fb5607 100%);
                border: none;
                font-weight: bold;
                box-shadow: 0 0 10px rgba(255, 190, 11, 0.4), inset 0 0 6px rgba(255, 255, 255, 0.2);
                border-radius: 4px 50% 50% 50%;
                transform: rotate(-45deg);
                span {
                  transform: rotate(45deg);
                }
              }
            }

            .supplier-name {
              flex: 1;
              font-size: 16px;
              color: #dae3f6;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-right: 10px;
              transition: color 0.3s ease;
            }

            .amount {
              font-size: 17px;
              color: #66ffff;
              font-weight: bold;
              min-width: 70px;
              text-align: right;
              flex-shrink: 0;
              transition: all 0.3s ease;
              position: relative;

              &::after {
                content: '';
                position: absolute;
                bottom: -2px;
                right: 0;
                width: 0;
                height: 2px;
                background: linear-gradient(90deg, transparent, #66ffff);
                transition: width 0.3s ease;
              }
            }

            &:hover .amount::after {
              width: 100%;
            }
          }
        }
      }
    }

    .chart-section {
      width: 45%;
      padding-left: 15px;
    }
  }
}
</style>
